<template>
    <MainContainer :footer="false" :style="{ 'padding-bottom': '80px' }">

            <div class="w-100 center mt4">
                <div class="flex items-center justify-between pb2">
                    <h5>Search Filters</h5>
                    <img class="pointer grow" src="@/assets/img/icon_x.svg" @click="$router.back();"/>
                </div>
                <FiltersCore ref="filtersCore"/>
            </div>
            <ActionBar class="z-5" :fixed="true" :style="{ 'height': '80px' }">
                <TooliabaButton @click="refineSearch">Refine Search</TooliabaButton>
            </ActionBar>

    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import FiltersCore from '@/components/search/FiltersCore.vue';
import ActionBar from '@/components/global/ActionBar.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        MainContainer,
        FiltersCore,
        ActionBar,
        TooliabaButton
    },
    methods: {
        refineSearch() {
            this.$refs.filtersCore.applyFilters();
        }
    }
};
</script>
